export { default as SelectedLifestylesSidebar } from './SelectedLifestylesSidebar';
